/* eslint-disable @typescript-eslint/no-unused-vars */
import { webClient } from "@shared/apis"

export default {
  query: async function (searchKeyword: string) {
    const { data } = await webClient({
      baseURL: process.env.REACT_APP_STOCK_SEARCH_URL,
      method: "get",
      url: "/search?&page=1&perPage=10&pagination=true",
      params: { q: searchKeyword },
    })

    return data
  },
}
